import { useEffect } from 'react';
import { APP_NAME } from '../config/branding';

/**
 * Custom hook to set the page title dynamically
 * This ensures Google Analytics tracks different titles for different pages
 *
 * The brand name suffix (e.g. "| HelpPetAI") is appended automatically.
 * Callers should NOT include the brand name in their title string.
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    const fullTitle = title 
      ? `${title} | ${APP_NAME}`
      : `${APP_NAME} - What PIMS should be. The all-in-one Practice Information Management System that evolves at the speed of AI. ✨Empowering ambitious teams from small Practice to Enterprises.`;
    document.title = fullTitle;
    
    // Send page view to Google Analytics with the new title
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: fullTitle,
        page_location: window.location.href,
        page_path: window.location.pathname
      });
    }
  }, [title]);
};
